import instance from '@/api/base';

// 站內文章／課程關鍵字搜尋（後端 GET /v1/article/search），回傳 [{ title, url, snippet }]
export async function searchArticles(keyword) {
  const rsp = await instance.get('/v1/article/search', {
    params: { q: keyword },
  });
  return rsp.data;
}

export default {
  searchArticles,
};
